export enum AdyenResultStatus {
    AUTHORISED = 'AUTHORISED',
    PAID = 'PAID',
    RECEIVED = 'RECEIVED',
    PENDING = 'PENDING',
    REFUSED = 'REFUSED',
    ERROR = 'ERROR',
    UNPAID = 'UNPAID',
    CANCELLED = 'CANCELLED'
}
